import { keepPreviousData } from '@tanstack/react-query';

import { TaskHistory, TaskId } from '@playq/services-jobot-scheduler';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

const taskStatusKeys: unknown[] = ['corp', 'webHooks', 'task'];

export const useIntegrationTaskStatus = (
  id?: TaskId,
  options?: IUseQueryOptionsExtended<TaskHistory | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery(taskStatusKeys.concat(id), () => services2.integrationsService.status(id as TaskId), {
    placeholderData: keepPreviousData,
    ...options,
    enabled: (options?.enabled ?? true) && id !== undefined,
  });

  return {
    taskHistory: res.data?.serialize(),
    ...res,
  };
};
